module.exports = __webpack_public_path__ + "media/images/word-excel-illustration-6e6f77fd9225c899cd53eb0f5d6681d7.svg";